import React from 'react';
import PropTypes from 'prop-types';
import { NUGGET, RUBY, SAPPHIRE, WCHIP, WSCORE } from 'utils/constants';
import WStoreGem from '../WStoreGem';
import './WStoreGems.css';

function WStoreGems({ item }) {
  const hasNuggetCost = !!item.nuggetCost;
  const hasRubyCost = !!item.rubyCost;
  const hasSapphireCost = !!item.sapphireCost;
  const hasWChipCost = !!item.wchipCost;
  const hasWScore = !!item.wscore;

  return (
    <div className="wstore-gems-container">
      <div className="wscore-gems-list">
        {hasWScore && <WStoreGem gemType={WSCORE} amount={item.wscore} />}
        {hasNuggetCost && (
          <WStoreGem gemType={NUGGET} amount={item.nuggetCost} />
        )}
        {hasRubyCost && <WStoreGem gemType={RUBY} amount={item.rubyCost} />}
        {hasSapphireCost && (
          <WStoreGem gemType={SAPPHIRE} amount={item.sapphireCost} />
        )}
        {hasWChipCost && <WStoreGem gemType={WCHIP} amount={item.wchipCost} />}
      </div>
    </div>
  );
}

WStoreGems.propTypes = {
  item: PropTypes.object
};

export default WStoreGems;
